// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OtLI","badges":"styles_badges__3vPq3"};